import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const productBOMSlice = createSlice({
    name: 'productBOM',
    initialState,
    reducers: {
        funGetProductBOM(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( productBOM ) => {
                return{
                    ...productBOM,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const productBOMActions = productBOMSlice.actions;
export default productBOMSlice.reducer;